import { Button as DefaultButton } from '@toggle/design-system';
import styled from 'styled-components';

export const Button = styled(DefaultButton)`
  background-color: transparent;
  height: 46px;
  color: var(--primary-color);
  width: 100%;
`;
